import { FormEvent, useEffect, useState } from "react";
import useStore from "../store/store";
import { IEmployee } from "../types/employee";
import dialogPolyfill from "../utils/diaglog-polyfill";

const DeleteEmployeeModal = ({ employeeId }: { employeeId: string }) => {
  const { removeEmployee, employees } = useStore();
  const [employee, setEmployee] = useState<IEmployee | undefined>();
  useEffect(() => {
    var dialog = document.querySelector("#deleteEmployeeModal");
    //@ts-ignore
    dialogPolyfill.registerDialog(dialog);
  }, []);

  useEffect(() => {
    setEmployee(employees.find((x) => x._id === employeeId));
  }, [employeeId, employees]);

  const submitForm = async (e: FormEvent) => {
    await removeEmployee(employeeId);
  };

  return (
    <dialog
      id="deleteEmployeeModal"
      className="border-none rounded-xl py-5 px-10 min-w-[500px] fixed left-0 top-0 mt-0"
    >
      <div className="flex items-center w-full justify-between">
        <h3 className="uppercase font-bold">Medewerker verwijderen?</h3>
        <button
          className="text-3xl"
          onClick={() => {
            //@ts-ignore
            document.getElementById("deleteEmployeeModal")!.close();
          }}
          type="reset"
        >
          &times;
        </button>
      </div>

      <form method="dialog" onSubmit={submitForm}>
        <div className="flex flex-col pt-2">
          <label htmlFor="eventName">
            Ben je zeker dat je {employee?.firstName} {employee?.lastName} wil
            verwijderen?
          </label>
        </div>

        <div className="flex justify-end pt-4">
          <button className="btn-primary mr-4">Verwijderen</button>
          <button
            className="btn-secondary"
            onClick={() => {
              //@ts-ignore
              document.getElementById("deleteEmployeeModal")!.close();
            }}
            type="reset"
          >
            Annuleren
          </button>
        </div>
      </form>
    </dialog>
  );
};

export default DeleteEmployeeModal;
